module.exports = __webpack_public_path__ + "static/Ocean Cheung.e843829f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Ocean Cheung.jpg
// module id = 1227
// module chunks = 6166952557895